<style lang="css">
@import '../css/bootstrap.css';
@import '../css/bootstrap-vue.css';

</style>
<style lang="scss">
$mainColor: #00698d;
.admin-header{
  position:relative;
  height:80px;
  top:0;
  left:0;
  width:100%;
  padding:0 50px;
  background:#00364a;
  z-index:100;
}
.container {
  display: flex;
}
.left-half {
  flex: 1;
  padding: 1rem;
  .logo{
    position:absolute;
    padding-left:234px;
    height:80px;
    top:0;
    background:url('../img/admin/white-logo.png') no-repeat left center;
    line-height:80px;
    font-size:24px;
    font-weight:bold;
    color:#fff;
    width:auto;
    margin-top:auto;
  }
}
.right-half {
  flex: 1;
  text-align: right;
  padding: 1rem;
  .logout-btn{
    width:auto;
    height:auto;
    margin-top:auto;
    position:absolute;
    top:0;
    font-size:14px;
    color:#ff4d73;
    font-weight: bold;
    line-height:80px;
    background:none;
  }
}
</style>
<style lang="scss" scoped>
@import '../css/admin.scss';
</style>
<template>
  <div class="user-template board-page">
    <header class="admin-header">
      <nav class="container">
        <div class="left-half">
          <router-link to="/"><h1 class="logo"></h1></router-link>
        </div>
        <div class="right-half">
          <button type="button" class="logout-btn" @click="myPageLogout()">로그아웃</button>
        </div>
      </nav>
    </header>
    <div class="user-page">
      <section class="user-section">
        <h2 class="sub-tit">찜한 매물<button type="button" class="more-btn" @click="toggle1">펼쳐보기 <b-icon-plus-circle></b-icon-plus-circle></button></h2>
        <div class="contents" v-if="!isHidden1">
          <ul class="mypage-list">
            <li class="list-item" v-for="(item, index) in myFavorite" :key="index">
              <router-link :to="{ name: 'ViewEstate', params: { id: item.estateId}}">
                <div class="item-area">
                  <div class="thumb">
                    <div class="thumb-img" v-if="item.fileName === ''">
                      <img src="../img/thumbnail-small.jpg" alt="">
                      <!-- <img src="../img/thumb-img-01.png" alt=""> -->
                    </div>
                    <div class="thumb-img" v-else>
                      <img :src="imgUrl + '/uploads/' + item.fileName" alt="">
                    </div>
                  </div>
                  <div class="desc">
                    <span class="label" :class="'label'+item.estateDeal">{{ getEstateTypeName(item.estateType) + ' - ' + getEstateDealName(item.estateDeal)}}</span>
                    <span class="price" v-if="item.estateDeal === '001'">{{item.estatePrice | numberToKor}}</span>
                    <span class="price" v-else>
                      <span v-if="item.estateDepo !== 0">보증금{{item.estateDepo | numberToKor}}</span>
                      <span v-if="item.estatePrice !== 0">월세{{item.estatePrice | numberToKor}}</span>
                    </span>
                    <!-- <span class="price" v-if="item.estatePrice <= 10000">최소 거래 금액은 천만원이상입니다.</span>
                    <span class="price" v-else><span v-if="item.estateDepo">보증금</span>{{item.estatePrice | numberToKor}}</span> -->
                    <span class="address">{{item.estateAddr1 + ' ' + item.estateAddr2 | truncate(10, '...')}}</span>
                    <span class="detail">{{item.estateDesc | truncate(40, '...')}}</span>
                  </div>
                  <button type="button" class="delete-btn" @click.prevent="delFavoriteItem(item)">
                    삭제
                  </button>
                </div>
              </router-link>
            </li>
          </ul>
        </div>
      </section>
      <section class="user-section">
        <h2 class="sub-tit">등록 매물<button type="button" class="btn btn-light" @click="goToRealEstateReg">매물 등록</button><button type="button" class="more-btn" @click="toggle2">펼쳐보기 <b-icon-plus-circle></b-icon-plus-circle></button></h2>
        <div class="contents" v-if="!isHidden2">
          <ul class="mypage-list">
            <li class="list-item" v-for="(item, index) in regEstate" :key="index">
                <div class="item-area">
                  <router-link :to="{ name: 'ViewEstate', params: { id: item.estateId}}">
                  <div class="thumb">
                    <div class="thumb-img" v-if="item.fileName === ''">
                      <img src="../img/thumbnail-small.jpg" alt="">
                      <!-- <img src="../img/thumb-img-01.png" alt=""> -->
                    </div>
                    <div class="thumb-img" v-else>
                      <img :src="imgUrl + '/uploads/' + item.fileName" alt="">
                    </div>
                  </div>
                  </router-link>
                  <div class="desc">
                    <div>
                      <span class="important" v-if="'N' === 'N'">
                        <span v-if="item.payStatus === 'WAITING_FOR_DEPOSIT'" class="label ready">결제대기</span>
                        <span v-else-if="item.payStatus === 'DONE'" class="label completion">결제완료</span>
                        <span v-else class="label free">무료등록</span>
                      </span>
                     <span class="label" :class="'label'+item.estateDeal">{{ getEstateTypeName(item.estateType) + ' - ' + getEstateDealName(item.estateDeal)}}</span>
                    </div>
                    <span class="price" v-if="item.estateDeal === '001'">{{item.estatePrice | numberToKor}}</span>
                    <span class="price" v-else>
                      <span v-if="item.estateDepo !== 0">보증금{{item.estateDepo | numberToKor}}</span>
                      <span v-if="item.estatePrice !== 0">월세{{item.estatePrice | numberToKor}}</span>
                    </span>
                    <!-- <span class="price" v-if="item.estatePrice <= 10000">최소 거래 금액은 천만원이상입니다.</span>
                    <span class="price" v-else><span v-if="item.estateDepo">보증금</span>{{item.estatePrice | numberToKor}}</span> -->
                    <span class="address">{{item.estateAddr1 + ' ' + item.estateAddr2 | truncate(10, '...')}}</span>
                    <span class="detail">{{item.estateDesc | truncate(40, '...')}}</span>
                  </div>
<!--                  <button type="button" class="deadline-btn" @click.prevent="deleteItem(item, index)">
                    매물삭제
                  </button>-->
                </div>
            </li>
          </ul>
        </div>
      </section>
      <section class="user-section">
        <h2 class="sub-tit">서식자료 구매내역<button type="button" class="more-btn" @click="toggle3">펼쳐보기 <b-icon-plus-circle></b-icon-plus-circle></button></h2>
        <div class="contents" v-if="!isHidden3">
          <ul class="board-list mypage-list">
            <li class="list-item" v-for="(item, index) in myDocument" :key="index">
              <div class="description">
                <span class="important" v-if="'N' === item.docFree">
                  <span class="label charged">유료</span>
                  <span v-if="item.payStatus === 'WAITING_FOR_DEPOSIT'" class="label ready">결제대기</span>
                  <span v-else-if="item.payStatus === 'DONE'" class="label completion">결제완료</span>
                  <span v-else class="label free"> - 결제완료</span>
                </span>
                <span class="label" v-else>무료</span>
                <span class="tit">{{ item.docTitle | truncate(20, '...')}}</span>
                <button type="button" class="item-btn download-btn" @click="downItem(item)">
                  다운로드<i class="icon download-icon"></i>
                </button>
              </div>
            </li>
          </ul>
        </div>
      </section>
      <section class="user-section">
        <h2 class="sub-tit">
          문의내역
          <button type="button" class="inquiry-btn" @click="initMyQna()">문의하기</button>
          <button type="button" class="more-btn" @click="toggle4">펼쳐보기 <b-icon-plus-circle></b-icon-plus-circle></button>
        </h2>
        <div class="contents" v-if="!isHidden4">
          <ul class="board-list mypage-list">
            <li class="list-item" v-for="(item, index) in myQna" :key="index">
              <div class="description inquiry">
                <span class="important">
                  <span class="label completion" v-if="'Y' === item.qnaAnswerYn">답변완료</span>
                  <span class="label ready" v-else>답변대기</span>
                </span>
                <span class="tit">{{ item.qnaTitle | truncate(20, '...')}}</span>
                <button type="button" class="item-btn download-btn" @click="boardDetailView(item)">
                  내용보기
                </button>
              </div>
              <button type="button" class="delete-btn"  @click.prevent="delMyQna(item)">삭제</button>
            </li>
          </ul>
        </div>
      </section>
      <section class="user-section">
        <h2 class="sub-tit">
          회원탈퇴
          <button type="button" class="inquiry-btn" @click="withdrawal()">탈퇴하기</button>
        </h2>
      </section>
      <div class="popup-template" v-if="boardDetail">
        <div class="popup-container">
          <div class="popup-contents mypage">
            <div class="header">
              <span class="title-column">
                <span class="label important" v-if="this.detailImportant === false">답변대기</span>
                <span class="label" v-else>답변완료</span>
                <span class="title">{{this.detailTit}}</span>
              </span>
                <span class="date">{{this.detailDate}}</span>
            </div>
            <div class="detail-container">
              <div class="contents-cloumn" v-html ="this.detailDesc" :class="{ reply: replyFlag }"></div>
              <p class="reply-tit" v-if="replyFlag">답변<span style="font-size:11px;color:#ccc;">{{this.detailAnsTime}}</span></p>
              <div class="contents-cloumn" v-if="replyFlag" :class="{ reply: replyFlag }">
                <div class="reply-contents" style="padding-left:10px;" v-html ="this.detailAns">
                </div>
              </div>
            </div>
            <div class="footer">
              <button type="button" class="close-btn" @click="boardDetail=true">닫기</button>
            </div>
          </div>
        </div>
      </div>
      <div class="popup-template" v-if="writeInquiry">
        <div class="popup-container">
          <div class="popup-contents mypage">
            <header id="modify-write___BV_modal_header_" class="modal-header">
              <h5 id="modify-write___BV_modal_title_" class="modal-title">문의하기</h5>
            </header>
            <div class="popup-column" style="margin-bottom:10px;">
              <b-form-input
                v-model="editQnaTitle"
                placeholder="질문사항 제목을 입력해 주세요."
                class="default-input"
                style="border: 1px solid #ccc;width: 100%;border-radius: 5px;height: 40px;padding:0 10px;"
              ></b-form-input>
            </div>
            <div class="contents">
              <quill-editor
                ref="newWriteEditor"
                v-model="newEditorContent"
                :options="newEditorOption"
              />
            </div>
            <div class="footer">
              <button type="button" class="save-btn" @click="regMyQna()">문의</button>
              <button type="button" class="close-btn" @click="writeInquiry=true">닫기</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AdminHeader from '@/components/AdminHeader'
import { mapGetters } from 'vuex'
export default {
  name: 'AdminBanner',
  components: {
    'admin-header': AdminHeader
  },
  data () {
    return {
      title: '마이페이지',
      isHidden1: true,
      isHidden2: true,
      isHidden3: true,
      isHidden4: true,
      choiceLimit: 3,
      registLimit: 3,
      formLimit: 3,
      inquiryLimit: 3,
      boardDetail: false,
      detailTit: '',
      detailDate: '',
      detailDesc: '',
      detailAns: '',
      detailAnsTime: '',
      detailImportant: false,
      writeInquiry: false,
      replyFlag: true,
      editQnaTitle: '',
      newEditorContent: '<h2>내용 입력</h2>',
      newEditorOption: {
        // Some Quill options...
      },
      imgUrl: this.$store.state.common.urlpath,
      fileRecords: []
    }
  },
  created () {
    this.$store.dispatch('apiEtcCodelists', {'Code': '001', 'DeCode': ''})
    this.$store.dispatch('apiEtcCodelists', {'Code': '002', 'DeCode': ''})
    if (this.checkLogin() === true) {
      this.$store.dispatch('apiEtcCodelists', {'Code': '001', 'DeCode': ''})
      this.$store.dispatch('apiEtcCodelists', {'Code': '002', 'DeCode': ''})
    } else {
      alert('해당 서비스는 로그인 이후 이용가능합니다.')
      this.$router.push('/Login')
    }
  },
  watch: {
    typeEstate () {
      if (this.typeEstate.length > 0 && this.typeDeal.length > 0) {
        if (sessionStorage.getItem('token') === null) {
          alert('세션 만료 또는 잘못된 접근 입니다.')
          this.$router.push('/Login')
        }
        this.$store.dispatch('apiMyFavorite')
        this.$store.dispatch('apiMyRegEstate')
        this.$store.dispatch('apiMyBuyDocument')
        this.$store.dispatch('apiMyQnaList')
      }
    },
    typeDeal () {
      if (this.typeEstate.length > 0 && this.typeDeal.length > 0) {
        if (sessionStorage.getItem('token') === null) {
          alert('세션 만료 또는 잘못된 접근 입니다.')
          this.$router.push('/Login')
        }
        this.$store.dispatch('apiMyFavorite')
        this.$store.dispatch('apiMyRegEstate')
        this.$store.dispatch('apiMyBuyDocument')
        this.$store.dispatch('apiMyQnaList')
      }
    }
  },
  methods: {
    toggle1: function () {
      this.isHidden1 = !this.isHidden1
    },
    toggle2: function () {
      this.isHidden2 = !this.isHidden2
    },
    toggle3: function () {
      this.isHidden3 = !this.isHidden3
    },
    toggle4: function () {
      this.isHidden4 = !this.isHidden4
    },
    checkLogin () {
      if (sessionStorage.getItem('di') === null) {
        return true
      } else {
        return true
      }
    },
    delFavoriteItem (item) {
      const deleteConfirm = confirm('정말 삭제하시겠습니까??')
      if (deleteConfirm === true) {
        const params = {
          'flag': 'D',
          'estateId': item.estateId
        }
        this.$store.dispatch('apiTranMyFavorite', params).then(() => {
          if (this.favoriteTran.result === 'success') {
            this.$store.dispatch('apiMyFavorite')
          } else {
            alert('처리 도중 문제가 발생하였습니다.')
          }
        })
      } else {
        return false
      }
    },
    itemDeadline () {
      alert('마감')
    },
    downItem (item) {
      if (item.docFree === 'Y') {
        // 무료
        this.downloadFile(item)
      } else {
        // 유료
        if (item.payStatus === 'DONE') {
          this.downloadFile(item)
        } else if (item.payStatus === 'WAITING_FOR_DEPOSIT') {
          alert('결제 대기 상태 입니다. 결제 완료 후 이용해주세요.')
        } else {
          this.downloadFile(item)
        }
      }
    },
    downloadFile (item) {
      const params = {
        'gubun': '02',
        'idDownFile': item.docId,
        'fileName': item.fileName
      }
      this.$store.dispatch('apiDownFiles', params)
    },
    boardDetailView: function (item) {
      this.boardDetail = true
      this.detailTit = item.qnaTitle
      this.detailDate = item.qnaQuestionTime
      this.detailDesc = item.qnaQuestion
      if (item.qnaAnswerYn === 'Y') {
        this.detailImportant = true
        this.replyFlag = true
        this.detailAns = item.qnaAnswer
        this.detailAnsTime = item.qnaAnswerTime
      } else {
        this.detailImportant = false
        this.replyFlag = false
        this.detailAns = ''
        this.detailAnsTime = ''
      }
    },
    saveMyQna (parms) {
      this.$store.dispatch('apiTranMyQna', parms).then(() => {
        if (this.qnaTran.result === 'success') {
          this.$store.dispatch('apiMyQnaList')
        } else {
          alert('처리 도중 문제가 발생하였습니다.')
        }
      })
    },
    regMyQna () {
      const regConfirm = confirm('문의하기를 등록하시겠습니까?')
      if (regConfirm === true) {
        const params = {
          'flag': 'I',
          'qnaTitle': this.editQnaTitle,
          'qnaQuestion': this.newEditorContent
        }
        this.saveMyQna(params)
        this.writeInquiry = false
      } else {
        return false
      }
    },
    delMyQna (item) {
      const deleteConfirm = confirm('정말 삭제하시겠습니까??')
      if (deleteConfirm === true) {
        const params = {
          'flag': 'D',
          'qnaId': item.qnaId
        }
        this.saveMyQna(params)
      } else {
        return false
      }
    },
    initMyQna () {
      this.editQnaTitle = ''
      this.newEditorContent = '<h2>내용 입력</h2>'
      this.writeInquiry = true
    },
    getEstateTypeName (type) {
      for (let i = 0; i <= this.typeEstate.length; i++) {
        if (this.typeEstate[i].deCode === type) {
          return this.typeEstate[i].codeNm
        }
      }
      return ''
    },
    getEstateDealName (type) {
      for (let i = 0; i <= this.typeDeal.length; i++) {
        if (this.typeDeal[i].deCode === type) {
          return this.typeDeal[i].codeNm
        }
      }
      return ''
    },
    withdrawal () {
      const withdrawakConfirm = confirm('정말 탈퇴하시겠습니까?\n탈퇴하시면 기존에 등록되었던 모든 데이터는 보관 되지 않습니다.\n그래도 하시겠습니까?')
      if (withdrawakConfirm) {
        this.$store.dispatch('apiTranMemberWithdraw').then(() => {
          if (this.withdrawTran.result === 'success') {
            sessionStorage.clear()
            alert('회원탈퇴가 완료되었습니다.')
            window.location.href = this.$store.state.common.urlpath
          } else {
            alert('처리 도중 문제가 발생하였습니다.')
          }
        })
      }
    },
    myPageLogout () {
      sessionStorage.clear()
      alert('로그아웃 되었습니다.')
      this.$router.push('/Login')
    },
    goToRealEstateReg () {
      this.$router.push('/Registration')
    },
    deleteItem (item, index) {
      // alert('삭제')
      // estateId
      const deleteConfirm = confirm('정말 삭제하시겠습니까??')
      if (deleteConfirm === true) {
        // 삭제 로직
        // console.log('item.estateId = ' + item.idEstate)
        this.$store.dispatch('apiAttachedFiles', {'Gubun': '01', 'idAtFile': item.idEstate, 'flag': 'SELECT'}).then((res) => {
          this.fileRecords = []
          for (let i = 0; i < this.fileInfo.length; i++) {
            // console.log('this.fileInfo = ' + JSON.stringify(this.fileInfo[i]))
            const info = this.getFileInfo(this.fileInfo[i])
            this.fileRecords.push(info)
          }
          // console.log('fileRecords = ' + this.fileRecords)
          this.callDeleteEstate(item.idEstate)
        }).catch(() => {
          alert('세션 만료 또는 잘못된 접근 입니다.')
        })
      }
    },
    getFileInfo (item) {
      let obj = []
      for (let i = 0; i < item.length; i++) {
        let file = {
          name: item[i].nameAtFile,
          file: { name: item[i].nameAtFile },
          url: this.imgUrl + item[i].path,
          lastModified: item[i].fileLast,
          size: item[i].fileSize,
          type: item[i].fileType,
          ext: item[i].fileExt
        }
        obj.push(file)
      }
      return obj
    },
    callDeleteEstate (id) {
      this.$store.dispatch('apiDeleteEstate', {'estateId': id, 'idAtFile': id, 'Gubun': '01'}).then(() => {
        // console.log('this.estateDelRtn = ' + this.estateDelRtn)
        this.$store.dispatch('apiMyRegEstate')
        this.deleteFiles(id)
      })
    },
    deleteFiles (id) {
      if (this.fileRecords.length > 0) {
        const params = {
          'deleteFiles': this.fileRecords,
          'gubun': '01',
          'idDtFile': id
        }
        this.$store.dispatch('apiDeleteFiles', params)
      }
    }
  },
  computed: {
    computedChoice () {
      return this.choiceLimit ? this.choiceItem.slice(0, this.choiceLimit) : this.choiceItem
    },
    computedRegist () {
      return this.registLimit ? this.registItem.slice(0, this.registLimit) : this.registItem
    },
    computedForm () {
      return this.formLimit ? this.formItem.slice(0, this.formLimit) : this.formItem
    },
    computedInquiry () {
      return this.inquiryLimit ? this.inquiryItem.slice(0, this.inquiryLimit) : this.inquiryItem
    },
    ...mapGetters({
      myFavorite: 'getMyFavorite',
      regEstate: 'getMyRegEstate',
      myDocument: 'getMyBuyDocument',
      myQna: 'getMyQnaList',
      typeEstate: 'getEtcCode001List',
      typeDeal: 'getEtcCode002List',
      qnaTran: 'getMyQnaTran',
      favoriteTran: 'getMyFavoriteTran',
      withdrawTran: 'getMyWithdraw',
      fileInfo: 'getAttachedFile'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/MyPage.vue